import { formInput, formRadioGroup, formRow, formSelect } from '@rocketfinancialcorp/rocket-ui/form';

import { Patterns } from '../patterns';

const isIbanCurrency = 'model.currency === "EUR"';

interface fieldsParams {
  categoryChangeHook: () => void;
}

export const createBAFinancialAccountFormFields = ({ categoryChangeHook }: fieldsParams) => {
  return [
    formRow([
      formRadioGroup({
        key: 'category',
        label: 'Account Category',
        props: {
          options: [
            { value: 'EXTERNAL', label: 'EXTERNAL' },
            { value: 'INTERNAL', label: 'INTERNAL', disabled: true },
            { value: 'INTEGRATED', label: 'INTEGRATED' },
          ],
          change: () => categoryChangeHook(),
        },
      }),
    ]),
    formRow(
      [
        formRadioGroup({
          key: 'cardOrBankAccount',
          label: 'Account Type',
          props: {
            options: [
              { value: 'bankAccount', label: 'Bank Account' },
              { value: 'card', label: 'Debit Card', disabled: true },
            ],
          },
        }),
      ],
      { className: 'account-type-row' },
    ),
  ];
};

export const integratedBankAccountFields = [
  formRow([
    formInput({
      key: 'name',
      label: 'Financial Account Nam\u0435',
      props: {
        pattern: Patterns.GENERIC_NAME,
        required: true,
      },
      validation: { messages: { pattern: 'Enter a valid Financial Account Nam\u0435' } },
    }),
  ]),
  formRow([formInput({ key: 'legalName', label: 'Account Holder Name', props: { required: true, disabled: true } })]),
  formRow([formInput({ key: 'subtype', label: 'Account Subtype', props: { required: true, disabled: true } })]),
];

export const externalBankAccountFields = [
  formRow([
    formInput({
      key: 'name',
      label: 'Financial Account Nam\u0435',
      props: {
        pattern: Patterns.GENERIC_NAME,
        required: true,
      },
      validation: { messages: { pattern: 'Enter a valid Financial Account Nam\u0435' } },
    }),
  ]),
  formRow([
    formRadioGroup({
      key: 'subtype',
      label: 'Bank Account Type',
      props: {
        options: [
          { label: 'Checking', value: 'CHECKING' },
          { label: 'Saving', value: 'SAVING' },
        ],
        required: true,
      },
      defaultValue: 'CHECKING',
    }),
  ]),
  formRow([
    formSelect({
      key: 'currency',
      label: 'Currency',
      props: {
        options: [
          { label: 'USD - US Dollar', value: 'USD' },
          { label: 'CAD - Canadian Dollar', value: 'CAD' },
          { label: 'EUR - Euro', value: 'EUR' },
        ],
        required: true,
      },
      defaultValue: 'USD',
    }),
  ]),
  formRow([
    formInput({ key: 'bankAccount.bankName', label: 'Bank Name', props: { required: true } }),
    formInput({
      key: 'bankAccount.routingNo',
      label: 'Routing No',
      props: { minLength: 9, maxLength: 9 },
      expressions: {
        'props.required': `!(${isIbanCurrency})`,
        hide: isIbanCurrency,
      },
    }),
  ]),
  formRow([
    formInput({
      key: 'bankAccount.nameOnAccount',
      label: 'Name on Account',
      props: { pattern: Patterns.GENERIC_NAME, minLength: 1, maxLength: 100, required: true },
      validation: { messages: { pattern: 'Enter a valid Name on Account' } },
    }),
  ]),
  {
    ...formRow([
      formInput({
        key: 'bankAccount.accountNumber',
        label: 'Account Number',
        props: {
          minLength: 4,
          maxLength: 20,
        },
        expressions: {
          'props.required': `!(${isIbanCurrency})`,
        },
      }),
    ]),
    expressions: { hide: isIbanCurrency },
  },
  {
    ...formRow([
      formInput({
        key: 'bankAccount.accountNumberConfirm',
        label: 'Confirm Account Number',
        expressions: {
          'props.disabled': '!model.bankAccount?.accountNumber',
          'props.required': `!(${isIbanCurrency})`,
        },
      }),
    ]),
    expressions: { hide: isIbanCurrency },
  },
  {
    ...formRow([
      formInput({
        key: 'bankAccount.iban',
        label: 'IBAN',
        props: {
          pattern: Patterns.IBAN,
          minLength: 15,
          maxLength: 34,
        },
        validation: { messages: { pattern: 'Enter a valid IBAN' } },
        expressions: {
          'props.required': isIbanCurrency,
        },
      }),
    ]),
    expressions: { hide: `!(${isIbanCurrency})` },
  },
  {
    ...formRow([
      formInput({
        key: 'bankAccount.bic',
        label: 'BIC',
        props: {
          pattern: Patterns.BIC,
          minLength: 8,
          maxLength: 11,
        },
        validation: { messages: { pattern: 'Enter a valid BIC' } },
      }),
    ]),
    expressions: { hide: `!(${isIbanCurrency})` },
  },
];
